export const DIALOG_TITLE = 'Archive Messaging Campaign';
export const DIALOG_MESSAGE = 'Are you sure you want to archive this SMS / Push notification?';
export const CONFIRM_BUTTON_TEXT = 'Archive';
export const ARCHIVE_SUCCESS_MESSAGE = 'The messaging campaign was successfully archived';
export const ARCHIVE_ERROR_MESSAGE =
  'Failed to archive the messaging campaign. Please try again later';
export const ARCHIVE_BUTTON_TITLE = CONFIRM_BUTTON_TEXT;
